// extracted by mini-css-extract-plugin
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--ab61f";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--0e7fa";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--25921";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--d0da7";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--c4b0e";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--375e5";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--d90b8";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--20182";